import { useAtomValue } from 'jotai';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { folderStateAtom, useEmailsContext } from '@/views/emails/context/EmailsContext.ts';

export const useCurrentThreadsQueryKey = () => {
  const { emailsState } = useEmailsContext();
  const folderState = useAtomValue(folderStateAtom);
  const { page, pageSize, search, sortBy, sortOrder, unreadOnly } = folderState;

  return [
    QueryKeyEnum.EMAILS.ALL,
    emailsState.selectedBox?.folderId,
    page,
    pageSize,
    sortBy,
    sortOrder,
    search,
    unreadOnly,
  ];
};
